import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { Box, Grid, Paper } from "@material-ui/core";
import { CorrespondenceSearch } from "../../components/correspondence-module/reports/CorrespondenceSearch";
import { ModulesType, TypeUser } from "../../enums/enums";
import { useStyles } from "../../shared/styles/useStyles";
import { CustomizedWindow } from "../../components/custom/CustomizedWindow";
import { AppState } from "../../redux/reducers/rootReducer";
import { useSelector, useDispatch } from "react-redux";
import { SettledDetails } from "../../components/document-managment/correspondence/SettledDetails";
import { useIntl } from "react-intl";
import { uiCloseModalSee } from "../../redux/actions/uiActions";
import { firebase } from "../../config/firebase/firebase-config";
import { setActiveCorrespondenceDocManagment } from "../../redux/actions/documentManagmentActions";
import moment from "moment";
import { SearchAddresseSender } from "../../components/correspondence-module/reports/SearchAddresseSender";
import { CorrespondenceStatistics } from "../../components/correspondence-module/reports/CorrespondenceStatistics";
import { CorrespondenceReceived } from "../../components/correspondence-module/reports/CorrespondenceReceived";
import { FollowupCorrespondenceReceived } from "../../components/correspondence-module/reports/FollowupCorrespondenceReceived";
import { useEffect, useState } from "react";
import { getOfficeEntityById } from "../../services/firebase/documentManagment";
import { Types } from "../../redux/types/types";

export const ReportsScreen = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const { activeCorrespondence } = useSelector((state: AppState) => state.documentManagment);
  const { modalSeeOpen } = useSelector((state: AppState) => state.ui);
  const { user } = useSelector((state: AppState) => state.auth);
  const [module, setModule] = useState("");

  // FECHA CORRESPONDENCIA ACTIVA
  const date = activeCorrespondence?.createAt && moment((activeCorrespondence.createAt as firebase.firestore.Timestamp).toDate()).format("YYYY/MM/DD - h:mm:ss");
  const onDeny = () => {
    dispatch(uiCloseModalSee());
    dispatch(setActiveCorrespondenceDocManagment(null));
  };

  const handleGetOffice = (idEntity: string, idOffice: string) => {
    getOfficeEntityById(idEntity, idOffice).then((response) => {
      if (response.ok) {
        let data = response.data[0];
        dispatch({ type: Types.loadOffice, payload: { id: data.idProductionOffice, name: data.name } })
      }
    });
  }

  useEffect(() => {
    if (user?.rol == TypeUser.OFFICER) {
      let part = user.offices ? user.offices[0].split("_") : "";
      let officeCode = part[0] + "_" + part[1];
      handleGetOffice(user.idEntity ? user.idEntity : "", officeCode);
    }
    if (window.location.pathname.includes("documentmanagment")) {
      setModule("management");
    } else {
      setModule("correspondence");
    }
  }, []);
  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Box>
        <Grid container spacing={1}>
          <Grid item xs={5}>
            <Paper square className={classes.paper}>
              <CorrespondenceSearch module={ModulesType.Correspondence} />
            </Paper>
          </Grid>
          <Grid item xs={7}>
            <Paper square className={classes.paper}>
              <SearchAddresseSender />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper square className={classes.paper}>
              <CorrespondenceStatistics module={{type: module, rol: user ? user.rol : ""}} />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper square className={classes.paperAuto}>
              <CorrespondenceReceived module={{type: module, rol: user ? user.rol : ""}} />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper square className={classes.paperAuto}>
              <FollowupCorrespondenceReceived module={{type: module, rol: user ? user.rol : ""}} />
            </Paper>
          </Grid>
        </Grid>

        <CustomizedWindow
          open={modalSeeOpen}
          content={<SettledDetails readonly />}
          onDeny={onDeny}
          title={`${intl.formatMessage({ id: "Settled" })} No. ${activeCorrespondence?.id
            } -  ${date}`}
        />
      </Box>
    </AppAnimate>
  );
};
